import { CustomJwtPayload } from "@/navigation/MainOutlet/Header";
import { jwtDecode } from "jwt-decode";

const useGetIdToken = () => {
    const idToken = localStorage.getItem('idToken');
    const decodedIdToken = idToken && typeof idToken === 'string' && (jwtDecode(idToken) as CustomJwtPayload);

    return decodedIdToken;
}

export default useGetIdToken